module.exports = __webpack_public_path__ + "img/map3.a98509cf.png";